// 以下所有的值 修改后重启或重新打包后 生效
import { iConfig } from '@/types/setting'
const config:iConfig = {
  // eslint-disable-next-line
  // BASE_URL: 'http://localhost:8080'
  // BASE_URL: 'http://10.160.196.1:12088'
  BASE_URL: 'http://114.115.146.252:8099'
}

export default config
